import { ElementRef, Injectable, ViewChild } from '@angular/core';
import Viewer from 'viewerjs';

@Injectable({
  providedIn: 'root'
})
export class ImagePreviewService {
  private el:ElementRef
  constructor(
    
  ) { }
 
  private createOverlay(imageList: string[],i?) {

    let images = imageList.map(img=>{
      return `<image src='${img}'/>`
    }).join('')
    let imageListCom = `
      <ul style='display:none' class='dsy-image-viewer-ul'>
        ${images}
      </ul>
    `
    let addon = `
      <div class='dsy-image-viewer'>${imageListCom}</div>
    `

    const d = document.querySelector('#dsy-image-viewer')

    if (d){
      d.innerHTML = addon
    } else {
      const x = document.createElement('div')
      x.setAttribute('id', 'dsy-image-viewer')
      document.body.appendChild(x)
      x.innerHTML = addon
    }

    const viewer = new Viewer(document.querySelector('.dsy-image-viewer-ul'), {
      toolbar: {
        zoomIn: 4,
        zoomOut: 4,
        oneToOne: 4,
        reset: 4,
        rotateLeft: 4,
        rotateRight: 4,
        flipHorizontal: 4,
        flipVertical: 4,
        prev: 4,
        play: true,
        next: 4,
      },
      view() {
        viewer.zoomTo(2);
      },
    });
    viewer && viewer.view(i)
  }


  preview(imageList: string[], i?: number) {
    this.createOverlay(imageList,i)
  }
  
}
